import { Box } from "@chakra-ui/layout";
import { Col, Row } from "antd";
import { PastaItem } from "core/features/documentos/typings";
import { useDeletePasta } from "core/features/documentos/hooks";
import { showConfirm, showErrorAxios } from "infra/helpers/alerta";
import { useLoading } from "components/GlobalLoading";
import Pasta from "./Pasta";
import { checkPermission } from "./../../../../../infra/helpers/permission";
import { PermissaoEnum } from "resources/enums/permissao";
import { TipoDestinoEnum } from "core/features/documentos/enums";
interface PastasProps {
  pastas: PastaItem[] | undefined;
  isLoading: boolean;
  selectedPasta?: string;
  setSelectedPasta: (id: string) => void;
  onEdit?: (
    id: string,
    name: string,
    destinoId: string,
    tipoDestinoId: TipoDestinoEnum | null
  ) => any;
  onDeleted: () => Promise<any>;
}

function Pastas({
  pastas,
  isLoading,
  selectedPasta,
  setSelectedPasta,
  onEdit,
  onDeleted,
}: PastasProps) {
  const { mutate: deletarPasta, isLoading: isLoadingDeletarPasta } =
    useDeletePasta();

  useLoading(isLoadingDeletarPasta);

  const onDelete = (id: string) => {
    showConfirm("Deseja realmente deletar essa pasta?").then(
      ({ isConfirmed }) => {
        if (isConfirmed) {
          deletarPasta(id, {
            onError: (e) => showErrorAxios(e),
            onSuccess: async () => {
              await onDeleted();
              if (id === selectedPasta) {
                setSelectedPasta("");
              }
            },
          });
        }
      }
    );
  };

  return (
    <Box as={Row} gutter={16}>
      {pastas?.map((p) => (
        <Box
          mb={4}
          as={Col}
          lg={6}
          xs={12}
          key={p.id}
          cursor="pointer"
          onClick={() => setSelectedPasta(p.id)}
          title={p.nome}
        >
          <Pasta
            pasta={p}
            isLoading={isLoading}
            selected={selectedPasta === p.id}
            onEdit={onEdit}
            onDelete={onDelete}
            hasPermissionDelete={checkPermission(
              PermissaoEnum.Backoffice.Administrativo.Documento.Pasta.Excluir
            )}
            hasPermissionEdit={checkPermission(
              PermissaoEnum.Backoffice.Administrativo.Documento.Pasta.Editar
            )}
          />
        </Box>
      ))}
    </Box>
  );
}

export default Pastas;
